import { FC, useEffect, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { getSessionId } from '../../helpers';

const LoggedIn: FC = () => {
  const [datalayer, setDatalayer] = useState<boolean>(null);
  let sessionId = getSessionId();

  useEffect(() => {
    if (sessionId) {
      setDatalayer(true);
    } else if (!sessionId) {
      setDatalayer(false);
    }
  }, [sessionId]);
  return (
    <>
      {datalayer != null && (
        <HelmetProvider>
          <Helmet>
            <script>
              {`
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'anvandarInfo': {
                        'inloggad': '${datalayer}'
                    }
                });
                `}
            </script>
          </Helmet>
        </HelmetProvider>
      )}
    </>
  );
};

export default LoggedIn;
